import { SingleSelectField } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { CarFleetStatus } from "../shared/types";

const options: CarFleetStatus[] = [CarFleetStatus.ACTIVE, CarFleetStatus.Passive, CarFleetStatus.NOT_RELEVANT];

interface Props {
	name: string;
	required?: boolean;
}

export const CarFleetStatusSelect: FC<Props> = ({ name, required }) => {
	const { t } = useTranslation();

	return (
		<SingleSelectField
			name={name}
			label={t("Car fleet status")}
			options={options}
			getLabel={(o) => t(o)}
			clearable={false}
			required={required}
		/>
	);
};
